import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const links = [
  { href: "#origem", label: "01 · História" },
  { href: "#processo", label: "02 · Processo" },
  { href: "#acervo", label: "03 · Acervo" },
  { href: "#encomendas", label: "04 · Encomendas" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 inset-x-0 z-40 transition-colors duration-500 ${
        scrolled
          ? "bg-[rgba(8,8,8,0.72)] backdrop-blur-xl border-b border-[var(--line)]"
          : "bg-transparent"
      }`}
      data-testid="site-nav"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          className="font-serif-display text-xl md:text-2xl tracking-tight"
          data-testid="nav-brand"
        >
          Acervo<span className="text-[var(--accent)]">.</span>3D
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="font-mono-tech text-[11px] text-[var(--ink-2)] hover:text-[var(--ink)] link-under transition-colors duration-300"
              data-testid={`nav-link-${l.href.replace("#", "")}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#encomendas"
          className="group inline-flex items-center gap-3 font-mono-tech text-[11px] px-4 py-2 border border-[var(--line-2)] hover:border-[var(--accent)] hover:text-[var(--accent)] transition-colors duration-300"
          data-testid="nav-cta-whatsapp"
        >
          <span>Encomendar</span>
          <span className="inline-block w-6 h-px bg-current group-hover:w-10 transition-[width] duration-500" />
        </a>
      </div>
    </motion.header>
  );
}
